// PR 45 review L6: the "Read again" refusal codes (POST /api/documents/read-again) in EN + AR. Merged into lib/i18n.js
// translations under errors.<CODE> (big-file rule: new strings in their own file); toErrMsg shows them for a non-en user.
export const I18N_PR45_DOCS = {
  en: {
    errors: {
      DOC_READ_AGAIN_NONE: "Select at least one document.",
      DOC_READ_AGAIN_TOO_MANY: "Up to 25 documents can be read again at once.",
      DOC_READ_AGAIN_ONE_ENGAGEMENT: "Select documents of one engagement.",
      DOC_READ_AGAIN_NOT_TEAM: "Only members of the engagement team can read documents again.",
      DOC_READ_AGAIN_BUSY: "A selected document is still being read — try again when it has finished.",
    },
  },
  ar: {
    errors: {
      DOC_READ_AGAIN_NONE: "حدد مستنداً واحداً على الأقل.",
      DOC_READ_AGAIN_TOO_MANY: "يمكن إعادة قراءة 25 مستنداً كحد أقصى في كل مرة.",
      DOC_READ_AGAIN_ONE_ENGAGEMENT: "حدد مستندات تخص مهمة واحدة.",
      DOC_READ_AGAIN_NOT_TEAM: "يمكن لأعضاء فريق المهمة فقط إعادة قراءة المستندات.",
      DOC_READ_AGAIN_BUSY: "لا يزال أحد المستندات المحددة قيد القراءة — حاول مرة أخرى بعد انتهائها.",
    },
  },
};

export default I18N_PR45_DOCS;
